<!--
  ~ Copyright (C) 2026 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->

<ptl-v3-dialog-shell
  [title]="data.titleKey | transloco"
  [description]="data.descriptionKey | transloco: { checkedMembersCount: memberCount }"
  [closeDisabled]="submitting()"
  (closed)="closeDialog()"
>
  <ptl-sg-input
    [formControl]="searchControl"
    [withIcon]="true"
    [icon]="LucideSearch"
    [clearable]="true"
    [ariaLabel]="data.searchLabelKey | transloco"
    [clearAriaLabel]="'translations.global.ariaLabels.clearSearch' | transloco"
    [placeholder]="data.searchPlaceholderKey | transloco"
  ></ptl-sg-input>

  @if (hasSelection()) {
    <div class="membership-dialog__selected">
      <span class="membership-dialog__selected-label">{{ 'translations.selected' | transloco: { count: selectedCount() } }}</span>
      <div class="membership-dialog__chips">
        @for (item of selected(); track item.id) {
          <div class="membership-dialog__chip">
            <span class="membership-dialog__chip-text" [attr.title]="item.label">{{ item.label }}</span>
            <button
              class="membership-dialog__chip-remove"
              type="button"
              [attr.aria-label]="'translations.global.ariaLabels.remove' | transloco: { name: item.label }"
              (click)="remove(item)"
            >
              <ptl-icon [icon]="LucideX" size="s"></ptl-icon>
            </button>
          </div>
        }
      </div>
    </div>
  }

  <div class="membership-dialog__results">
    @if (showLoading()) {
      <p class="membership-dialog__state">{{ 'translations.global.label.loading' | transloco }}</p>
    } @else if (showEmptyState()) {
      <p class="membership-dialog__state">{{ data.emptyKey | transloco }}</p>
    } @else {
      <div class="membership-dialog__list-wrap">
        <ul class="membership-dialog__list">
          @for (item of candidates(); track item.id) {
            <li class="membership-dialog__item">
              <ptl-sg-checkbox [checked]="selectedIds().has(item.id)" [ariaLabel]="item.label" (checkboxChange)="toggle(item)">
                <span class="membership-dialog__option-name" [attr.title]="item.label">{{ item.label }}</span>
                @if (item.sublabel) {
                  <span class="membership-dialog__option-type">{{ item.sublabel }}</span>
                }
              </ptl-sg-checkbox>
            </li>
          }
        </ul>

        <ptl-busy-overlay
          [active]="loading()"
          [spinner]="true"
          [label]="'translations.global.ariaLabels.icons.loading' | transloco"
        ></ptl-busy-overlay>
      </div>

      @if (canLoadMore()) {
        <div class="membership-dialog__more">
          <ptl-button
            type="link-color"
            size="s"
            [text]="'translations.showMore' | transloco"
            [loading]="loadingMore()"
            [disabled]="loading()"
            (clicked)="onShowMore()"
          ></ptl-button>
        </div>
      }
    }
  </div>

  <ng-container dialogFooter>
    <ptl-button
      type="secondary-neutral"
      size="m"
      [disabled]="submitting()"
      [text]="'translations.global.button.cancel' | transloco"
      (clicked)="closeDialog()"
    ></ptl-button>
    <ptl-button
      type="secondary-alert"
      size="m"
      [icon]="LucideTrash2"
      [disabled]="!hasSelection() || submitting()"
      [loading]="pendingAction() === 'remove'"
      [text]="data.removeButtonKey | transloco"
      (clicked)="submit('remove')"
    ></ptl-button>
    <ptl-button
      type="primary"
      size="m"
      [disabled]="!hasSelection() || submitting()"
      [loading]="pendingAction() === 'add'"
      [text]="data.addButtonKey | transloco"
      (clicked)="submit('add')"
    ></ptl-button>
  </ng-container>
</ptl-v3-dialog-shell>
